// src/components/Home.jsx
import React, { useState, useEffect, useRef } from "react";
import "./Home.css";

export default function Home({ onOpenLogin }) {
  const carouselImages = [
    "https://res.cloudinary.com/dmecovtmm/image/upload/v1770513805/sdw_yokpyn.jpg",
    "https://res.cloudinary.com/dmecovtmm/image/upload/v1770513805/fff_pr9w2a.jpg",
    "https://res.cloudinary.com/dmecovtmm/image/upload/v1770514482/fddfv_rqykt5.jpg",
    "https://res.cloudinary.com/dmecovtmm/image/upload/v1770513805/gt_xw5vrr.jpg",
    "https://res.cloudinary.com/dmecovtmm/image/upload/v1770478597/tela_fl9qav.png"
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [sobreOpen, setSobreOpen] = useState(false);
  const [contatoOpen, setContatoOpen] = useState(false);

  const sobreRef = useRef(null);
  const contatoRef = useRef(null);

  // Fecha balloons ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sobreRef.current && !sobreRef.current.contains(e.target)) setSobreOpen(false);
      if (contatoRef.current && !contatoRef.current.contains(e.target)) setContatoOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isPaused]);

  const nextSlide = () => { setCurrentSlide((prev) => (prev + 1) % carouselImages.length); setIsPaused(true); };
  const prevSlide = () => { setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length); setIsPaused(true); };
  const goToSlide = (index) => { setCurrentSlide(index); setIsPaused(true); };

  return (
    <div className="home-new-container">

      {/* Seção 1 */}
      <section className="home-section home-hero-section">
        <div className="home-hero-content">
          <div className="home-hero-gif-side">
            <img src="https://res.cloudinary.com/dmecovtmm/image/upload/v1770566047/ongif1_qzdzte.gif" alt="OnBox em ação" className="home-hero-gif" />
          </div>
          <div className="home-hero-text-side">
            <h1 className="home-new-title">Do escritório ao canteiro, tudo conectado.</h1>
          </div>
        </div>
        <div className="home-hero-subtitle">
          <p className="home-new-subtitle">
            Suas equipes de campo e de escritório trabalhando de forma colaborativa, em tempo real, tudo em um único aplicativo e com as principais funcionalidades utilizadas no dia a dia da construção civil.
          </p>
        </div>
      </section>

      {/* Seção 2 */}
      <section className="home-section">
        <div className="home-image-wrapper">
          <img src="https://res.cloudinary.com/dmecovtmm/image/upload/v1770478596/tela2_zps4i3.png" alt="OnBox Interface" className="home-main-image" />
        </div>
      </section>

      {/* Seção 3 */}
      <section className="home-section">
        <div className="home-features-grid">
          {[
            { icon: "text_ad", label: "Atas de reunião" },
            { icon: "task", label: "Tarefas" },
            { icon: "calendar_month", label: "Calendário" },
            { icon: "contract_edit", label: "Diário de obra" },
            { icon: "target", label: "Metas" },
            { icon: "list_alt_add", label: "Lista de materiais" },
            { icon: "notifications_active", label: "Lembretes" },
            { icon: "view_kanban", label: "Kanban" },
          ].map(({ icon, label }) => (
            <div className="home-feature-card" key={label}>
              <span className="home-feature-icon material-symbols-outlined">{icon}</span>
              <span className="home-feature-text">{label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Seção 4 */}
      <section className="home-section home-text-image-section">
        <div className="home-text-image-content">
          <div className="home-text-side">
            <p className="home-benefits-text">Projetos e setores que interagem entre si, reduzindo tempo de espera e de pesquisa, troca de informações mais rápida.</p>
          </div>
          <div className="home-image-side">
            <div className="home-carousel" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
              <div className="home-carousel-track">
                {carouselImages.map((image, index) => (
                  <div key={index} className={`home-carousel-slide ${index === currentSlide ? 'active' : ''}`}>
                    <img src={image} alt={`OnBox Slide ${index + 1}`} className="home-carousel-image" />
                  </div>
                ))}
              </div>
              <button className="home-carousel-btn home-carousel-btn-prev" onClick={prevSlide} aria-label="Imagem anterior">
                <span className="material-symbols-outlined">arrow_back</span>
              </button>
              <button className="home-carousel-btn home-carousel-btn-next" onClick={nextSlide} aria-label="Próxima imagem">
                <span className="material-symbols-outlined">arrow_forward</span>
              </button>
              <div className="home-carousel-dots">
                {carouselImages.map((_, index) => (
                  <button key={index} className={`home-carousel-dot ${index === currentSlide ? 'active' : ''}`} onClick={() => goToSlide(index)} aria-label={`Ir para slide ${index + 1}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção 5: CTA */}
      <section className="home-section home-cta-section">
        <div className="home-cta-content">
          <h2 className="home-cta-title">Faça parte do OnBox.</h2>
          <button className="home-cta-button" onClick={onOpenLogin}>Começar Agora</button>
        </div>
      </section>

      {/* Seção 6: Rodapé da Home */}
      <section className="home-footer-section">
        <div className="home-footer-inner">
          <img
            src="https://res.cloudinary.com/dmecovtmm/image/upload/v1774466349/boxy4a_e75wjf.png"
            alt="OnBox"
            className="home-footer-logo"
          />
          <nav className="home-footer-nav">

            {/* Sobre nós */}
            <div className="home-footer-popup-wrap" ref={sobreRef}>
              <button
                className="home-footer-link home-footer-btn"
                onClick={() => { setSobreOpen(o => !o); setContatoOpen(false); }}
              >
                Sobre nós
              </button>
              {sobreOpen && (
                <div className="home-footer-balloon home-footer-balloon--sobre">
                  <button className="home-balloon-close" onClick={() => setSobreOpen(false)}>✕</button>
                  <div className="home-balloon-inner">
                    <img
                      src="https://res.cloudinary.com/dmecovtmm/image/upload/v1774466349/boxy3a_psevke.png"
                      alt="Boxy"
                      className="home-balloon-boxy"
                    />
                    <div className="home-balloon-body">
                      <h3 className="home-balloon-title">Conheça o OnBox</h3>
                      <p className="home-balloon-text">
                        O OnBox nasceu dentro de obras reais, de quem sentiu na prática o custo
                        de uma informação que chega tarde, de uma tarefa que ninguém assumiu
                        e de uma reunião que não virou ação.
                      </p>
                      <p className="home-balloon-text">
                        É uma plataforma feita para qualquer projeto, do pequeno e simples ao maior e mais complexo, funcionam melhor, com menos
                        reuniões improdutivas, menos retrabalho e mais clareza para todo o time.
                      </p>
                      <ul className="home-balloon-list">
                        <li><span>•</span> Atas que geram tarefas com responsável e prazo, sem depender de e-mail</li>
                        <li><span>•</span> Equipe de campo e escritório vendo as mesmas informações em tempo real</li>
                        <li><span>•</span> Diário de obra digital: registros rápidos, sem papel e acessíveis depois</li>
                        <li><span>•</span> Alertas automáticos para prazos vencendo, sem precisar cobrar manualmente</li>
                        <li><span>•</span> Materiais, tarefas e metas organizados por projeto, tudo em um lugar</li>
                        <li><span>•</span> Histórico completo de decisões e atividades, rastreável a qualquer momento</li>
                      </ul>
                      <p className="home-balloon-footer-text">
                        Menos ruído. Mais obra feita.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <span className="home-footer-sep">|</span>

            {/* Fale conosco */}
            <div className="home-footer-popup-wrap" ref={contatoRef}>
              <button
                className="home-footer-link home-footer-btn"
                onClick={() => { setContatoOpen(o => !o); setSobreOpen(false); }}
              >
                Fale conosco
              </button>
              {contatoOpen && (
                <div className="home-footer-balloon home-footer-balloon--contato">
                  <button className="home-balloon-close" onClick={() => setContatoOpen(false)}>✕</button>
                  <a href="mailto:contato@onboxapp.com.br" className="home-balloon-email">
                    contato@onboxapp.com.br
                  </a>
                </div>
              )}
            </div>

          </nav>
        </div>
      </section>

    </div>
  );
}